import React from 'react'
import {
  PawPrint,
  Pencil,
  // Upload as UploadIcon,
} from 'lucide-react'
// import { ValidateError } from '@/components/common/ValidateError'
// import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/styled'

// type ImageUploaderModes = 'default' | 'dashed'

interface ImageUploaderProps {
  imagePreview: string | null
  onImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const ImageUploader = React.memo(
  ({ imagePreview, onImageUpload }: ImageUploaderProps) => {
    return (
      <div className={cn('relative mx-auto')}>
        <div
          className={cn(
            'w-32 h-32 flex flex-col items-center justify-center bg-white rounded-full border-2 border-solid border-black cursor-pointer hover:border-gray-400 hover:text-gray-400 transition-colors',
            imagePreview && 'text-gray-400 hover:text-gray-400 border-gray-400'
          )}
          onClick={() => document.getElementById('image-upload')?.click()}
        >
          {imagePreview ? (
            <img
              src={imagePreview}
              alt='Event'
              className='w-full h-full object-cover rounded-full'
            />
          ) : (
            <>
              <PawPrint className='w-10 h-10 transition-colors' />
              <div className='absolute bottom-3 right-1 bg-white border-2 border-solid border-black rounded-full p-1'>
                <Pencil className='w-4 h-4 text-black hover:text-black' />
              </div>
            </>
          )}
        </div>
        <input
          id='image-upload'
          type='file'
          accept='image/*'
          className='hidden'
          onChange={onImageUpload}
        />
      </div>
    )
  }
)
